import type React from "react";
import TreeItem, { type TreeItemProps } from "../../common/Tree/TreeItem";
import InstanceIndex from "../../common/InstanceIndex/InstanceIndex";
import Chip from "../../common/Chip/Chip";
import styles from "./GraphData.module.scss";
import clsx from "clsx";

const GraphDataTreeItem: React.FC<TreeItemProps> = (props) => {
  const { node, style, className, ...otherProps } = props;
  const info = (node?.data as any)?.info || {};
  const isInstance = info.type === "instance";

  return (
    <TreeItem
      {...otherProps}
      node={node}
      className={clsx(styles.treeItem, className)}
      style={style}
    >
      <TreeItem.Arrow />
      {isInstance ? (
        <div data-deci-part="graphdata-treeitem-instance-label" className={styles.treeInstanceLabel}>
          <InstanceIndex path={String(node.id)} />
        </div>
      ) : (
        <TreeItem.Label />
      )}
      <div data-deci-part="graphdata-treeitem-badges" className={styles.treeBadges}>
        {info.warnings ? (
          <Chip data-deci-part="graphdata-badge" size="sm" variant="warning" className={styles.badge}>
            <Chip.Label>{info.warnings}</Chip.Label>
          </Chip>
        ) : null}
        {info.errors ? (
          <Chip data-deci-part="graphdata-badge" size="sm" variant="destructive" className={styles.badge}>
            <Chip.Label>{info.errors}</Chip.Label>
          </Chip>
        ) : null}
        {(info.containsErrors || info.containsWarnings) && !info.errors && !info.warnings ? (
          <div
            data-deci-part="graphdata-dot"
            data-variant={info.containsErrors ? "error" : "warning"}
          />
        ) : null}
      </div>
    </TreeItem>
  );
};

export default GraphDataTreeItem;
